import { useState } from "react"

/**
 * Custom hook to manage the visibility state of an Appbar.
 *
 * @param {Object} props - Configuration props for useAppbar hook.
 * @param {boolean} [props.defaultVisible=false] - Initial visibility state of the Appbar.
 * @returns {Object} return - An object containing the visibility state and functions to control it.
 * @returns {boolean} return.visible - The current visibility state of the Appbar.
 * @returns {() => void} return.open - Function to set the Appbar as visible.
 * @returns {() => void} return.close - Function to set the Appbar as hidden.
 */
export const useAppbar = ({ defaultVisible = false } = {}) => {
  const [visible, setVisible] = useState(defaultVisible)

  const open = () => {
    setVisible(true)
  }

  const close = () => {
    setVisible(false)
  }

  return { visible, open, close }
}
